var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const generateUrl_1 = __importDefault(require("./generateUrl"));
const generateBody_1 = __importDefault(require("./generateBody"));
const getHTTPVerb_1 = __importDefault(require("./getHTTPVerb"));
const generateHeaders_1 = __importDefault(require("./generateHeaders"));
const abortableFetch_1 = __importDefault(require("../abortableFetch"));
const validateRequestOptions_1 = __importDefault(require("./validateRequestOptions"));
const isTesting_1 = __importDefault(require("../isTesting"));
const AbortablePromise_1 = __importDefault(require("../AbortablePromise"));
const parseISODates_1 = __importDefault(require("../valueTransformers/parseISODates"));
const tokenAuth_1 = require("../tokenAuth");
function makeRequest(requestOptions) {
    (0, validateRequestOptions_1.default)(requestOptions);
    const { timeout, mock } = requestOptions;
    if ((0, isTesting_1.default)()) {
        const mockValue = mock || null;
        return new AbortablePromise_1.default(Promise.resolve(mockValue), () => { });
    }
    const request = sendRequest(requestOptions).then(response => processResponse(response, requestOptions));
    request.catch(err => {
        if (err.message === '401') {
            (0, tokenAuth_1.handleAuthSite401Response)();
        }
    });
    if (timeout) {
        window.setTimeout(() => request.abort(), timeout);
    }
    return request;
}
function sendRequest(requestOptions) {
    const url = (0, generateUrl_1.default)(requestOptions);
    const headers = (0, generateHeaders_1.default)(requestOptions);
    const body = (0, generateBody_1.default)(requestOptions);
    const fetchOptions = {
        method: (0, getHTTPVerb_1.default)(requestOptions.action),
        headers,
        body,
        credentials: 'include'
    };
    if (requestOptions.noCors) {
        fetchOptions.mode = 'no-cors';
    }
    return (0, abortableFetch_1.default)(url, fetchOptions).then(response => handle401(response, requestOptions));
}
async function handle401(response, requestOptions) {
    if (response.status !== 401) {
        return response;
    }
    if (requestOptions.doNotRetry) {
        throw Error('401');
    }
    await (0, tokenAuth_1.getNewAccessToken)(true).then(token => {
        (0, tokenAuth_1.saveToken)(token);
    });
    return sendRequest(Object.assign(Object.assign({}, requestOptions), { doNotRetry: true }));
}
async function processResponse(response, requestOptions) {
    const responseContentType = response.headers.get('content-type');
    const isResponseJSON = responseContentType && /application\/json/i.test(responseContentType);
    if (response.ok) {
        if (isResponseJSON) {
            let responseValue = await response.json();
            const { keepDatesAsStrings } = requestOptions.responseOptions || {};
            // apply any response filters here
            responseValue = (0, parseISODates_1.default)(responseValue, { keepDatesAsStrings });
            return responseValue;
        }
        if (response.status === 204) {
            return null;
        }
        return getBlobWithFileName(response);
    }
    if (response.type === 'opaque') {
        // special case for "no-cors" requests. You aren't allowed to read the response for those, so just don't do anything
        return;
    }
    // we've got an error, so normalize it, then throw it
    if (isResponseJSON) {
        const error = await response.json();
        if (error.hasOwnProperty('TimeStamp')) {
            const serviceError = new Error(error.Message);
            serviceError.name = 'ServiceError';
            serviceError.stack = `${serviceError.name}: ${serviceError.message}\n${error.StackTrace}`;
            serviceError.data = error;
            throw serviceError;
        }
        const err = new Error(error.ExceptionMessage || error.Message || error.exceptionMessage || error.message);
        err.data = error;
        throw err;
    }
    else if (responseContentType && /text\/plain/i.test(responseContentType)) {
        const errorMessage = await response.text();
        throw new Error(errorMessage);
    }
    throw new Error('ERROR: Network response was ' + response.status + ' - ' + response.statusText);
}
function getBlobWithFileName(response) {
    const responseContentDisposition = response.headers.get('content-disposition');
    let fileName = '';
    if (responseContentDisposition && responseContentDisposition.indexOf('attachment') > -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(responseContentDisposition);
        if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, '');
        }
    }
    return response.blob().then(blob => ({ blob, fileName }));
}
exports.default = makeRequest;
//# sourceMappingURL=index.js.map